import React from 'react';
import styled from 'styled-components';
import {
  spacer24,
  screenSmMax,
  spacer16,
} from '@spotify-internal/encore-foundation';
import { ContentfulImage } from '../Contentful/ContentfulImage';
import { ContentfulAsset } from '../Contentful';
import { HeadlineWithSupertextComponent, ImageAspectBox21x9 } from './index';

const FeaturedContent = styled.div`
  background-color: ${({ theme }) => theme.box.background};
  color: ${({ theme }) => theme.box.text};
`;

const HeaderContent = styled.div`
  display: flex;
  flex-direction: column;
  padding-top: ${(props: { padding: string }) => props.padding};

  @media (max-width: ${screenSmMax}) {
    padding-top: 0px;
    padding-bottom: ${spacer16};
    flex-direction: column-reverse;
  }
`;

const ImageContainer = styled(ImageAspectBox21x9)``;

const InnerText = styled.div`
  max-width: 815px;
  padding-top: ${spacer24};

  @media (max-width: ${screenSmMax}) {
    padding-top: 0;
  }
`;

type FeaturedContentComponentType = {
  supertext?: string;
  headline?: string;
  image?: ContentfulAsset;
  useFeaturedContentHeadline: boolean;
  caption?: string;
};

export const FeaturedContentHeadline: React.FC<FeaturedContentComponentType> = ({
  supertext = '',
  headline = '',
  image,
  useFeaturedContentHeadline,
  caption = '',
}) => {
  const padding = image ? `${spacer24}` : '0px';
  return (
    <FeaturedContent>
      <HeaderContent padding={padding}>
        {image && (
          <ImageContainer>
            <ContentfulImage asset={image} caption={caption} />
          </ImageContainer>
        )}

        {useFeaturedContentHeadline && headline && (
          <InnerText>
            <HeadlineWithSupertextComponent
              supertext={supertext}
              headline={headline}
            />
          </InnerText>
        )}
      </HeaderContent>
    </FeaturedContent>
  );
};
